import React from 'react';
import { motion } from 'framer-motion';
export const Benefits = () => {
  const items = ['✅ Tratado Práctico de Defensa del Consumidor 2026.', '🎁 Biblioteca de 100 Modelos Editables.', '🎁 Sistema Express de Evaluación de Casos.', '🎁 Kit Profesional de Cartas Documento.', '🔒 Garantía de devolución de 7 días.', '⚡ Acceso inmediato y de por vida.'];
  return <section className="py-12 bg-legal-800 border-y border-legal-700" data-id="element-31">
      <div className="container mx-auto px-4" data-id="element-32">
        <div className="max-w-2xl mx-auto" data-id="element-33">
          <div className="text-center mb-12" data-id="element-34">
            <h2 className="text-3xl md:text-4xl font-serif font-bold text-white" data-id="element-35">
              Todo lo que incluye tu compra
            </h2>
          </div>

          <div className="bg-legal-900 rounded-2xl p-8 md:p-10 border border-legal-700 shadow-xl" data-id="element-36">
            <ul className="space-y-5" data-id="element-37">
              {items.map((item, idx) => <motion.li key={idx} initial={{
              opacity: 0,
              x: -16
            }} whileInView={{
              opacity: 1,
              x: 0
            }} viewport={{
              once: true
            }} transition={{
              duration: 0.4,
              delay: idx * 0.08
            }} className="flex items-start gap-3 text-lg text-slate-200" data-id="element-38">
                  <span data-id="element-39">{item}</span>
                </motion.li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
};